import { graphql } from "gql.tada";

const TopologyActionsMut = graphql(`
  mutation invokeTopologyAction($input: InvokeTopologyActionInput!) {
    invokeTopologyAction(input: $input)
  }
`);

const WizardUpdateDetailsMut = graphql(`
  mutation editWizardDetails($input: EditWizardDetailsInput!) {
    editWizardDetails(input: $input) {
      status
      message
    }
  }
`);

const WizardUpdateZoneMut = graphql(`
  mutation editZoneDetails($input: EditZoneDetailsInput!) {
    editZoneDetails(input: $input) {
      status
      message
    }
  }
`);

export { TopologyActionsMut, WizardUpdateZoneMut, WizardUpdateDetailsMut };
